import { RichTextField, ScItem, ShortPhraseFields } from '@/types/sitecore';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { FormPatternValidatorFields } from '@/types/form/validator';
import { FormFieldGroupFields } from '@/types/form/form-field-group';
import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';

export interface DynamicFormProps {
  form?: ScItem<DynamicFormFields>;
  showSearchIcon?: boolean;
}
export interface DynamicFormEmits {
  (e: 'iconClick', iconKey: string, value: string): void;
  (e: 'change', fieldType: string, fieldName: string, value: string, originValue?: any): void;
}
export interface DynamicFormFields {
  items: Array<ScItem<DynamicFormField | FormFieldGroupFields>>;
  externalData: Field<string>;
  itemBorderColor: Field<string>;
  itemBackColor: Field<string>;
  itemForeColor: Field<string>;
  itemCurtainBackColor: Field<string>;
  itemCurtainColor: Field<string>;
  checkboxBackColor: Field<string>;
  checkboxBorderColor: Field<string>;
  checkboxForeColor: Field<string>;
  checkboxActiveBackColor: Field<string>;
  checkboxActiveForeColor: Field<string>;
}
export interface DynamicFormRef {
  el: HTMLDivElement;
  validate<T>(): Promise<DynamicFormValidateResult<T>>;
  focusFirstInvalid(): void;
  updateFields(items: DynamicFormUpdateParam): void;
  resetFields(): void;
  setDisabled(isDisabled: boolean): void;
  getValues(): Record<string, any>;
}
export interface DynamicFormContext {
  regFormEl(fieldRef: DynamicFormFieldRef): void;
  unRegFormEl(fieldRef: DynamicFormFieldRef): void;
}
export interface BaseDynamicFormFieldRef {
  el: HTMLElement | null;
  type: string;
  id: string;
}
export interface DynamicFormFieldRef extends BaseDynamicFormFieldRef {
  name: string;
  visible: boolean;
  setRequired(required: boolean): void;
  setDisabled(disabled: boolean): void;
  setVisible(visible: boolean): void;
  updateValue(value?: string | null): void;
  getValue(): any;
  validate(): Promise<DynamicFormFieldValidateResult>;
}
export interface DynamicFormField {
  fieldName: Field<string>;
  fieldType?: ScItem<ShortPhraseFields>;
  label?: RichTextField;
  description?: RichTextField;
}
export interface FormElementProps {
  item: ScItem<DynamicFormField>;
}

export interface DynamicFormValueField extends DynamicFormField {
  fieldName: Field<string>;
  required: Field<boolean>;
  requiredMsg: Field<string>;
  tooltip?: RichTextField;
  validators?: Array<ScItem<FormPatternValidatorFields>>;
}
export interface DynamicFormUpdateParam {
  [key: string]: DynamicFormUpdateFieldParams;
}
export interface DynamicFormUpdateFieldParams {
  value?: string | null | undefined | any;
  visible?: boolean;
  disabled?: boolean;
  required?: boolean;
  options?: FormDropdownOption[];
  visibleValues?: string[];
  startData?: number | null;
  endData?: number | null;
}
export interface DynamicFormValidateResult<T> {
  data?: T;
  valid: boolean;
  errors: string[];
}
export interface DynamicFormFieldValidateResult {
  valid: boolean;
  value?: any;
  message?: string;
}
export interface DynamicFormData {
  externalData?: any;
  [key: string]: any;
}
export const FormFieldTypes = [
  'FormFieldGroup',
  'FormInput',
  'FormTextarea',
  'FormDropdown',
  'FormCheckbox',
  'FormCheckList',
  'FormAutoComplete',
  'FormUpload',
  'FormDate',
];
